import { forwardRef } from 'react';
import { Link } from '@/i18n/routing';

//* Context
import { withLanguageContext } from '@/context';

const CustomLink = forwardRef(({ style, url, className, prefetch = true, scroll = true, replace = false, external = false, translate, selectedLang, ...props }, ref) => {
	return (
		<Link
			ref={ref}
			style={style}
			scroll={scroll}
			replace={replace}
			prefetch={prefetch}
			className={`link-item ${className || ''}`}
			rel={external ? 'noopener noreferrer' : ''}
			target={external ? '_blank' : props.target || '_self'}
			href={typeof url === 'object' ? { ...url } : url}
			aria-label={translate(props.text ? props.text.replaceAll('/', '') : props.ariaLabel || (typeof url == 'object' ? url?.pathname.replaceAll('/', '') : url?.replaceAll('/', '')))}>
			{props.children || (props.content ? translate(props.content) : null)}
		</Link>
	);
});

export default withLanguageContext(CustomLink, ['selectedLang', 'translate']);
